import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=1ce227f4&scoped=true&"
import script from "./FirstPage.vue?vue&type=script&lang=js&"
export * from "./FirstPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce227f4",
  null
  
)

export default component.exports